import { format } from 'date-fns';
import { IonButton, IonRow, IonCol } from '@ionic/react';
import ReactDataSheet, { DataEditor } from 'react-datasheet';
import 'react-datasheet/lib/react-datasheet.css';

const measurementsFromLoad = (load, depthIncrement) => {
  const minPileRows = (load.depth + 5) / depthIncrement;
  const rows = _.max([minPileRows, 10]);
  return _.times(rows, (i) => [null, (i + 1) * depthIncrement]);
};

const withHeaders = (values) => [
  [
    {value: "Time", readOnly: true, width: "150px"},
    {value: "Depth (ft)", readOnly: true},
    {value: "Pressure (psi)", readOnly: true},
    {value: "Load (lbs)", readOnly: true},
  ],
  ...values
];

const hydrate = (measurements) => withHeaders(_.map(measurements, (row) => [
  {value: row[0] || '', className: 'time-cell'},
  {value: row[1] || '', className: 'number-cell'},
  {value: row[2] || '', className: 'number-cell'},
  {value: row[3] || '', className: 'number-cell'},
]));

const TimeEditor = ({onChange, value, onKeyDown}) => {
  return <div>
    <input value={value} onChange={(e) => onChange(e.target.value)} onKeyDown={onKeyDown} autoFocus/>
    <IonButton color="tertiary" onClick={() => onChange(format(new Date(), 'p'))} size="small">Now</IonButton>
  </div>;
};

export default function PushPierMeasurements({load, depthIncrement, measurements, onChange}) {
  const data = measurements || measurementsFromLoad(load, depthIncrement);

  const addRow = () => {
    onChange([...data, []]);
  };
  const removeRow = () => {
    onChange(_.slice(data, 0, data.length - 1));
  };

  return <>
    <ReactDataSheet
      data={hydrate(data)}
      valueRenderer={(cell) => cell.value}
      dataEditor={(props) => (
        props.cell.className === 'time-cell' ? (
          <TimeEditor {...props} />
         ) : <DataEditor {...props} />
      )}
      onCellsChanged={(changes) => {
        const newMeasurements = _.cloneDeep(data);
        changes.forEach(({row, col, value}) => {
          newMeasurements[row - 1][col] = value;
        });
        onChange(newMeasurements);
      }}
      className="log-table"
    />
    <IonRow>
      <IonCol>
        <IonButton onClick={addRow} color="tertiary" size="small" expand="block">
          + Add Row
        </IonButton>
      </IonCol>
      <IonCol>
        <IonButton onClick={removeRow} color="warning" size="small" expand="block">
          - Remove Row
        </IonButton>
      </IonCol>
    </IonRow>
  </>;
}
